/**
 * Types of VAS Classifier Codes (Roadside Assist or Services and Repairs or FuelPay)
 * @enum
 */
const Vas = {
  RSA_H: 'H', 
  RSA_HC: 'HC',
  RSA_P: 'P', 
  RSA_PC: 'PC', 
  RSA_T: 'T', 
  RSA_TC: 'TC', 
  RSA_YA: 'YA', 
  RSA_NC: 'NC', 

  SNR_YA: 'YA', 
  SNR_Y: 'Y', 
  SNR_YC: 'YC', 
  SNR_NC: 'NC',

  FP_YA: 'YA',
  FP_Y: 'Y',
  FP_YC: 'YC',
  FP_NC: 'NC'
};

export default Vas;